import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import MarketBwhiteApi from '../../../API/market/bwhite-api';
import { Column, Row, WhiteBlock } from '../../../components/Basic/Blocks';
import { Button, SendButton } from '../../../components/Basic/Buttons';
import { Content } from '../../../components/Basic/Global';
import { TYPE_BUTTONS } from '../../../constans';
import BwhiteTable from './Table';
import styles from './styles.module.scss';

const BwhitePage = () => {
  const dispatch = useDispatch();

  const [provider, changeProvider] = useState();
  const [providers, setProviders] = useState([]);
  const [providerData, setProviderData] = useState({ status_stock: '', date_stock_update: null });

  const [market, setMarket] = useState('kuper1');
  const allProviders = useSelector((store) => store.providers);
  const user = useSelector((store) => store.user);

  useEffect(() => {
    const p = allProviders.filter((item) => !item['hide']);
    if (p.length > 0) {
      setProviders(p);
      changeProvider(p[0] || {});
    } else {
      changeProvider({ name: '' });
    }
  }, [allProviders]);

  useEffect(() => {
    if (provider) {
      console.log(provider);
      setProviderData(provider.markets_update?.['kuper']);
    }
  }, [provider]);

  const isOwner = user.role === 'owner' || user.role === 'admin';

  return (
    <>
      <Content>
        <WhiteBlock title="Управление" title_bold={`B-White`} style={{ margin: '10px 0' }} minimize={true}>
          <Row style={{ alignItems: 'stretch' }}>
            <Column className={styles.stosks_column}>

              <Row style={{ marginTop: '10px' }}>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketBwhiteApi.excelFeed({ data: { shop: 'bwhite1' } })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать yml
                </Button>
                <Button
                  type={TYPE_BUTTONS.WHITE}
                  onClick={() => MarketBwhiteApi.excelCatalog({ data: { shop: 'bwite1' } })}
                  style={{ marginRight: '15px' }}
                >
                  Скачать каталог
                </Button>

                <SendButton
                  sendApi={MarketBwhiteApi.saveBwhiteId}
                  sendData={{ data: { shop: 'bwhite1' } }}
                  style={{ marginRight: '15px' }}
                >
                  Подгрузить id
                </SendButton>
              </Row>
            </Column>
          </Row>
        </WhiteBlock>

        <BwhiteTable />
      </Content>
    </>
  );
};

export default BwhitePage;
